import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const About = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="about-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <SEO path="/about" title="About AFHOS" description="Learn about the African Federation of Hypertension Organisations and Societies — our mission, vision, and commitment to reducing cardiovascular disease burden in Africa." />
      <div className="page-header">
        <p className="overline">{t('about.overline')}</p>
        <h1 data-testid="about-title">{t('about.title')}</h1>
        <p>{t('about.subtitle')}</p>
      </div>

      <div className="image-section">
        <img src="https://images.unsplash.com/photo-1576089235406-0612d7bb033e?w=900&h=400&fit=crop" alt="African medical professionals" />
      </div>

      <div className="content-section">
        <h2>{t('about.whoWeAre')}</h2>
        <p>{t('about.whoWeAreP1')}</p>
        <p>{t('about.whoWeAreP2')}</p>
      </div>

      <div className="content-section">
        <h2>{t('about.vision')}</h2>
        <p>{t('about.visionDesc')}</p>
      </div>

      <div className="content-section">
        <h2>{t('about.mission')}</h2>
        <p>{t('about.missionDesc')}</p>
      </div>

      <div className="content-section">
        <h2>{t('about.objectives')}</h2>
        <div className="grid-3" style={{ marginTop: '1rem' }}>
          <div className="card">
            <h4 style={{ color: 'var(--brand)', marginBottom: '0.5rem' }}>{t('about.research')}</h4>
            <p style={{ fontSize: '0.9rem', color: 'var(--muted)' }}>{t('about.researchDesc')}</p>
          </div>
          <div className="card">
            <h4 style={{ color: 'var(--brand)', marginBottom: '0.5rem' }}>{t('about.education')}</h4>
            <p style={{ fontSize: '0.9rem', color: 'var(--muted)' }}>{t('about.educationDesc')}</p>
          </div>
          <div className="card">
            <h4 style={{ color: 'var(--brand)', marginBottom: '0.5rem' }}>{t('about.advocacy')}</h4>
            <p style={{ fontSize: '0.9rem', color: 'var(--muted)' }}>{t('about.advocacyDesc')}</p>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>{t('about.structure')}</h2>
        <p>{t('about.structureDesc')}</p>
      </div>
    </div>
  );
};

export default About;
